import { useParams } from 'react-router-dom';
import { Category } from './categories/Category';
import { ANALYTICS_SUITE_CATEGORY_IDS } from '../constants/navigation';
import { jsx as _jsx } from "react/jsx-runtime";
export const MostPopularTemplates = ({
  templates
}) => {
  const {
    tabId
  } = useParams();
  return /*#__PURE__*/_jsx(Category, {
    id: ANALYTICS_SUITE_CATEGORY_IDS.MOST_POPULAR,
    labelKey: `reports.sidebar.collections.popular.${tabId}`,
    tooltipKey: 'smartLibrary.analyticsSuite.categories.tooltips.popular',
    templates: templates
  });
};